const idPrefix = 'configurator';

export const elementIDs = {
  controlPanelAndPreviewChildContainer: `${idPrefix}-controlPanelAndPreviewChildContainer`,
  controlPanelAndPreviewParentContainer: `${idPrefix}-controlPanelAndPreviewParentContainer`,
  controlPanelContainer: `${idPrefix}-controlPanelContainer`,
  controlPanelHeaderText: `${idPrefix}-controlPanelHeader`,
  controlPanelSubHeaderText: `${idPrefix}-controlPanelSubHeader`,
  headerText: `${idPrefix}-headerText`,
  messagingConfiguratorContainer: `${idPrefix}-eligibleContainer`,
  previewSectionContainer: `${idPrefix}-previewSectionContainer`,
  previewSectionSubHeaderText: `${idPrefix}-previewSectionSubHeaderText`,
  previewSectionDarkModeToggle: `${idPrefix}-previewSectionDarkModeToggle`,
  publishButton: `${idPrefix}-publishButton`,
  subHeaderText: `${idPrefix}-subHeaderText`,
  legacyConfigWarningContainer: `${idPrefix}-legacyConfigWarningContainer`
};
